// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-d77cc898]{font-weight:500;display:inline-block;margin-right:10px;vertical-align:top;background-color:grey}.confirmText[data-v-d77cc898]{font-size:15px;font-weight:bolder;margin-bottom:5px}", ""]);
// Exports
module.exports = exports;
